import React from 'react';
import { bool, func, string } from 'prop-types';
import CompensationSummaryCard from '../CompensationSummaryCard/CompensationSummaryCard';

class InternalJobDescription extends React.Component {
  static propTypes = {
    checked: bool,
    data: string,
    onToggle: func,
    isConfigVisible: bool
  };

  render() {
    const { checked, data, onToggle, isConfigVisible } = this.props;
    const hasData = data && data.length > 0 ? true : false;
    const bodyText = hasData ? data : 'No Internal Job Description Uploaded';
    const textClass = hasData ? 'internal__description' : 'comp-sum-card__empty-title';
    return (
      <CompensationSummaryCard
        cardTitle="Internal Job Description"
        checked={checked}
        onToggle={onToggle}
        isConfigVisible={isConfigVisible}
        hasData={hasData}
      >
        <div className={textClass}>{bodyText}</div>
      </CompensationSummaryCard>
    );
  }
}

export default InternalJobDescription;
